var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddChekMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 2H7.83333C3.6912 2 2 3.6912 2 7.83333V16.1667C2 20.3088 3.6912 22 7.83333 22H16.1667C20.3088 22 22 20.3088 22 16.1667V7.83333C22 3.6912 20.3088 2 16.1667 2Z",
    fill: "#91C176",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8211 8.18315C18.0596 8.42737 18.0596 8.82333 17.8211 9.06754L11.3149 15.7253C10.9569 16.0916 10.3765 16.0916 10.0185 15.7253L7.179 12.8196C6.94033 12.5754 6.94033 12.1795 7.179 11.9353C7.41765 11.691 7.80458 11.691 8.04323 11.9353L10.6667 14.6198L16.9567 8.18315C17.1954 7.93895 17.5824 7.93895 17.8211 8.18315Z",
    fill: "#699F4D",
    stroke: "#699F4D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddChekMark);
export default __webpack_public_path__ + "static/media/addChekMark.60c0d3ca761c1dd6ef0bb6ce26bea3f0.svg";
export { ForwardRef as ReactComponent };